import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const OrderStatusUpdate = ({ order, id, dispatch, updateOrderAdmin, onOrderUpdate }) => {
  const [formData, setFormData] = useState({
    pending: order.pending,
    completed: order.completed,
  });
  const [showCompletionModal, setShowCompletionModal] = useState(false);
  const { pending, proccess, completed } = order;
  
  const handleSubmit = (e) => {
    e.preventDefault();
    sendNotificationToClient({
      business_type: "update",
      message: `Your Order with Order ID : ${
        formData ? formData?.order?.slug : "nj13n448255j13n"
      } has been Updated by the Service Provider!`,
    });
    dispatch(updateOrderAdmin(id, formData));
    
    // Call the callback to refresh the order data
    if (onOrderUpdate) {
      onOrderUpdate();
    }
  };

  const handleCompletedChange = () => {
    // Check if we're trying to mark as completed
    if (!formData.completed) {
      // Get the ending date from the order
      const endingDate = order.ending_date || order.order?.ending_date;
      
      if (endingDate) {
        const today = new Date();
        const orderEndDate = new Date(endingDate);
        
        // Check if today is before the order end date
        if (today < orderEndDate) {
          const daysDifference = Math.ceil((orderEndDate - today) / (1000 * 60 * 60 * 24));
          setShowCompletionModal(true);
          return; // Don't update the form data yet
        }
      }
    }
    
    // If no date validation needed or date is valid, proceed with normal update
    const updatedFormData = { ...formData, completed: !formData.completed };
    setFormData(updatedFormData);
    
    // Immediately submit the form to update the order status
    sendNotificationToClient({
      business_type: "update",
      message: `Your Order with Order ID : ${
        formData ? formData?.order?.slug : "nj13n448255j13n"
      } has been Updated by the Service Provider!`,
    });
    dispatch(updateOrderAdmin(id, updatedFormData));
    
    // Call the callback to refresh the order data
    if (onOrderUpdate) {
      onOrderUpdate();
    }
  };

  const handleConfirmCompletion = () => {
    const updatedFormData = { ...formData, completed: !formData.completed };
    setFormData(updatedFormData);
    setShowCompletionModal(false);
    
    // Immediately submit the form to update the order status
    sendNotificationToClient({
      business_type: "update",
      message: `Your Order with Order ID : ${
        formData ? formData?.order?.slug : "nj13n448255j13n"
      } has been Updated by the Service Provider!`,
    });
    dispatch(updateOrderAdmin(id, updatedFormData));
    
    // Call the callback to refresh the order data
    if (onOrderUpdate) {
      onOrderUpdate();
    }
  };

  const handleCancelCompletion = () => {
    setShowCompletionModal(false);
  };

  function sendNotificationToClient(order) {
    const notification = order;
    const existingNotifications =
      JSON.parse(localStorage.getItem("notifications")) || [];
    existingNotifications.push(notification);
    localStorage.setItem(
      "notifications",
      JSON.stringify(existingNotifications),
    );
  }

  // Calculate days difference for display
  const getDaysDifference = () => {
    const endingDate = order.ending_date || order.order?.ending_date;
    if (endingDate) {
      const today = new Date();
      const orderEndDate = new Date(endingDate);
      return Math.ceil((orderEndDate - today) / (1000 * 60 * 60 * 24));
    }
    return 0;
  };

  return (
    <>
      <form>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            onChange={() =>
              setFormData((prev) => ({
                ...prev,
                pending: !prev.pending,
              }))
            }
            checked={formData.pending}
            id="pending"
            disabled={pending}
          />
          <label className="form-check-label" htmlFor="pending">
            Reserved (In Progress)
          </label>
        </div>

        {order.pending && (
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              onChange={handleCompletedChange}
              checked={formData.completed}
              id="completed"
              disabled={completed}
            />
            <label className="form-check-label" htmlFor="completed">
              Completed
            </label>
          </div>
        )}
        {order.completed ? (
          ""
        ) : (
          <button
            onClick={handleSubmit}
            className="btn btn-dark mt-3 text-dark"
          >
            Update
          </button>
        )}
      </form>

      {/* Early Completion Warning Modal */}
      <Modal show={showCompletionModal} onHide={handleCancelCompletion} centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ color: '#202224', fontWeight: '700' }}>
            Early Completion Warning
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '2rem' }}>
          <div className="text-center">
            <div className="mb-3">
              <i className="fas fa-exclamation-triangle" style={{ fontSize: '3rem', color: '#ffcc00' }}></i>
            </div>
            <h5 className="mb-3" style={{ color: '#202224', fontWeight: '600' }}>
              Your order is supposed to be completed on {new Date(order.ending_date || order.order?.ending_date).toLocaleDateString('en-US', {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
              })}
            </h5>
            <p className="mb-4" style={{ color: '#202224', fontSize: '16px' }}>
              You're completing this order <strong>{getDaysDifference()} days</strong> earlier than scheduled.
            </p>
            <p className="mb-0" style={{ color: '#666', fontSize: '14px' }}>
              Are you sure you want to mark this order as completed now?
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer style={{ 
          border: 'none', 
          padding: '1rem 2rem 2rem 2rem',
          justifyContent: 'center',
          gap: '1rem'
        }}>
          <Button
            variant="outline-secondary"
            onClick={handleCancelCompletion}
            style={{
              border: '2px solid #6c757d',
              color: '#6c757d',
              fontWeight: '600',
              padding: '0.5rem 2rem',
              borderRadius: '8px'
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmCompletion}
            style={{
              backgroundColor: '#ffcc00',
              border: 'none',
              color: '#000034',
              fontWeight: '600',
              padding: '0.5rem 2rem',
              borderRadius: '8px'
            }}
          >
            Update Anyway
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default OrderStatusUpdate;
